import React, { useEffect, useState } from 'react';
import AppRoutes from './routes';
import './App.css';
import UserContext from './contexts/UserContext';
import Api from './services/Api';
import { useReactPWAInstall } from "react-pwa-install";
import logoApp from "./assets/logo192.png";
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CountryProvider } from './contexts/CountryContext';
import i18n from './i18n';
//import { fetchToken, onMessageListener } from './firebase';

const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  return parts[0]
};


function App() {
  const [user, setUser] = useState([]);
  const [modalInstallApp, setModalInstallApp] = useState(false);
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: '', body: '' });
  const [isTokenFound, setTokenFound] = useState(false);
  //fetchToken(setTokenFound);

  useEffect(() => {
    const user_id = localStorage.getItem('user');
    if (user_id) {
      validaLogin(user_id);
    }

    const pathSegments = window.location.pathname.split('/');
    if (pathSegments.includes('dashboard')) {
      setModalInstallApp(true);
    } else {
      setModalInstallApp(false);
    }
  }, []);

  async function validaLogin(user_id) {
    const response = await Api.getUser(user_id);
    if (response !== null) {
      setUser([response]);
    }
  }

  /*onMessageListener().then(payload => {
    setNotification({title: payload.notification.title, body: payload.notification.body})
    setShow(true);
    console.log(payload);
  }).catch(err => console.log('failed: ', err));

  const onShowNotificationClicked = () => {
    setNotification({title: "Notification", body: "This is a test notification"})
    setShow(true);
  }*/

  //PWA Install button
  const installApp = () => {
    pwaInstall({
      title: "Instalar Aplicativo",
      logo: logoApp,
    })
      .then(() => alert("Operação realizada com sucesso!"))
      .catch(() => console.log("Instalação cancelada..."));
  };

  // Função para detectar o idioma do navegador
  const detectBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage;
    const lang = browserLang.split('-')[0];

    const langRoutes = {
      'pt': '/pt',
      'en': '/en',
      'es': '/es',
      'fr': '/fr',
      'it': '/it',
      'de': '/de',
      'nl': '/nl'
    };

    return langRoutes[lang] || '/en';
  };

  return (
    <BrowserRouter>
      <CountryProvider>
        <UserContext.Provider
          value={{
            user: user,
            setUser: (usr) => {
              console.log(usr);
              setUser(usr);
            },
            logout: () => { },
          }}
        >
          <Switch>

            {/* Rota para redirecionamento de idioma na raiz */}
            <Route exact path="/" render={(props) => <Redirect to={{ pathname: detectBrowserLanguage(), search: props.location.search }} />} />

            {/* Rotas com prefixo de idioma (apenas idiomas suportados) */}
            <Route path="/:lang(pt|en|es|fr|it|de|nl)" component={AppRoutes} />

            {/* Rota para qualquer outro caminho (sem prefixo ou rotas normais como /login) */}
            <Route component={AppRoutes} />
          </Switch>

          {/*supported() && !isInstalled() && modalInstallApp && (
            <div className="divBtnInstallApp">
              <button className="btnCloseInstallApp" onClick={() => setModalInstallApp(false)}>✘</button>
              <div className="row v-center">
                <div className="col-6 col-md-8">
                  <h5>Instalar o App?</h5>
                  <p>Instale o app e desfrute da experiência completa!</p>
                </div>
                <div className="col-6 col-md-4 text-center">
                  <button className="btn-small btn-default" onClick={installApp}>
                    Instalar Aplicativo
                  </button>
                </div>
              </div>
            </div>
          )*/}
        </UserContext.Provider>
        <ToastContainer />
      </CountryProvider>
    </BrowserRouter>
  );
}

export default App;
